import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { BrokerBanner } from '../../../components/BrokerBanner';
import { useGetInfoBrokerLanding } from '../../../hooks/broker';

export function BrokerBannerContainer() {
  const infoBrokerLanding = useGetInfoBrokerLanding();

  const handleButtonClick = React.useCallback(
    () => window.open(infoBrokerLanding, '_blank', 'noopener'),
    [infoBrokerLanding],
  );

  return (
    <ActionAfterViewObserver callback={() => {}} triggerOnce>
      <BrokerBanner onClick={handleButtonClick} />
    </ActionAfterViewObserver>
  );
}
